import { useCallback } from 'react';
import { FileUploadItemProps } from './types';

export const useFileUploadItem = (props: FileUploadItemProps) => {
  const { file, onDelete, disabled = false } = props;

  const handleDelete = useCallback(() => {
    if (disabled) return;
    onDelete(file.id);
  }, [file.id, onDelete, disabled]);

  const getFileTypeDisplayName = (): string => {
    const extension = file.name.split('.').pop()?.toUpperCase();
    return extension ? `${extension} File` : 'Unknown File';
  };

  return {
    handleDelete,
    getFileTypeDisplayName,
    disabled,
  };
};
